import script from "./collapsible-split-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./collapsible-split-panel.vue?vue&type=script&setup=true&lang=js"

import "./collapsible-split-panel.vue?vue&type=style&index=0&id=14b2b894&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14b2b894"]])

export default __exports__